import { render, staticRenderFns } from "./activity-questions.vue?vue&type=template&id=7a2c9b24&scoped=true&"
import script from "./activity-questions.vue?vue&type=script&lang=js&"
export * from "./activity-questions.vue?vue&type=script&lang=js&"
import style0 from "./activity-questions.vue?vue&type=style&index=0&id=7a2c9b24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2c9b24",
  null
  
)

component.options.__file = "activity-questions.vue"
export default component.exports